import { useState, memo } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { truncateText } from "../../utils/helpers";
import "./inputFields.scss";

function InputFileUpload({
  register,
  getValues,
  watch,
  fileChange,
  fileName,
  isMobile,
  name = "file",
}) {
  const [selectedFiles, setSelectedFiles] = useState([]);

  return (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      className={`w-100 accordion-allocation-board capitalize d-flex justify-content-flex-start ${
        isMobile ? `justify-content-center` : `white-button file-upload-button`
      }`}
      startIcon={!fileName && <CloudUploadIcon />}
    >
      {!fileName && selectedFiles.name && truncateText(selectedFiles.name, 12)}
      {!fileName && !selectedFiles.name
        ? "Upload file"
        : truncateText(fileName, 12)}
      <input
        id="input-file-field"
        multiple
        type="file"
        className="visually-hidden-input"
        onChange={(e) => {
          setSelectedFiles(e.target.files);
          fileChange(e);
        }}
      />
    </Button>
  );
}

export default memo(InputFileUpload);
